import type { ConceptDef } from '../types';

export const receptiveBodyParts: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-body-parts',
  label: 'Receptive Body Parts',
  category: 'Receptive',
  description: 'Hear a body part and tap its picture.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'hand', answer: '✋ hand' },
      { say: 'foot', answer: '🦶 foot' },
      { say: 'eye', answer: '👁 eye' },
      { say: 'ear', answer: '👂 ear' },
      { say: 'nose', answer: '👃 nose' },
      { say: 'mouth', answer: '👄 mouth' },
      { say: 'leg', answer: '🦵 leg' },
      { say: 'arm', answer: '💪 arm' },
    ],
  },
};
